(() => {
  'use strict';

  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));

  const updateBodyLock = () => {
    const hasOpenLayer = Boolean($('.mobile-menu.is-open, .cart-drawer.is-open, .filter-drawer.is-open, .search-modal.is-open, .wishlist-drawer.is-open, dialog[open]'));
    document.body.classList.toggle('is-locked', hasOpenLayer);
  };

  const showToast = (message) => {
    const toast = $('[data-toast]');
    if (!toast || !message) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timeout);
    showToast.timeout = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  const formatMoney = (cents, format = window.Passion?.moneyFormat || '{{amount}}') => {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = Number(cents || 0);
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    const formatWithDelimiters = (amount, precision = 2, thousands = '.', decimal = ',') => {
      if (Number.isNaN(amount) || amount == null) return '0';
      const fixed = (amount / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    };

    const match = format.match(placeholderRegex);
    if (!match) return formatWithDelimiters(value);

    let result;
    switch (match[1]) {
      case 'amount':
        result = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals':
        result = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_comma_separator':
        result = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        result = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        result = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        result = formatWithDelimiters(value);
    }
    return format.replace(placeholderRegex, result);
  };

  /* v0.9.6 - Product WhatsApp hard guarantee.
     On product pages every WhatsApp entry point (the product CTA and the
     floating bubble) receives the live product context at click time. */
  const getProductWhatsappUrl = () => {
    const root = $('[data-product-root]');
    if (!root) return '';

    const form = $('.js-product-form', root);
    const productWhatsapp = $('[data-product-whatsapp]', root);
    if (!form || !productWhatsapp) return '';

    let variants = [];
    const variantScript = $('[data-variant-json]', root);
    if (variantScript) {
      try {
        variants = JSON.parse(variantScript.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    const selectedValues = $$('[data-product-option]:checked', form).map((input) => input.value);
    const optionInputs = $$('[data-product-option]', form);
    let variant = null;

    if (optionInputs.length && variants.length) {
      variant = variants.find((candidate) =>
        Array.isArray(candidate.options) &&
        candidate.options.length === selectedValues.length &&
        candidate.options.every((option, index) => option === selectedValues[index])
      ) || null;
    }

    if (!variant && variants.length) {
      const currentId = String($('[name="id"]', form)?.value || '');
      variant = variants.find((candidate) => String(candidate.id) === currentId) || variants[0] || null;
    }

    const productTitle = productWhatsapp.dataset.productTitle || $('.product-info__title', root)?.textContent?.trim() || document.title;
    const variantTitle = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
    const giftMessage = $('[name="properties[Mesaj felicitare]"]', form)?.value?.trim() || '';
    const bubble = $('[data-whatsapp-bubble]');
    let whatsappNumber = String(productWhatsapp.dataset.whatsappNumber || bubble?.dataset.whatsappNumber || '40745951111').replace(/\D/g, '');
    if (whatsappNumber.startsWith('0')) whatsappNumber = `40${whatsappNumber.slice(1)}`;

    const fallbackBase = `${window.location.origin}${window.location.pathname}`;
    const configuredBase = productWhatsapp.dataset.productUrl || fallbackBase;
    let productUrl = configuredBase;

    try {
      const url = new URL(configuredBase, window.location.origin);
      if (variant?.id) url.searchParams.set('variant', variant.id);
      productUrl = url.toString();
    } catch (error) {
      productUrl = configuredBase;
    }

    const lines = [
      'Bună ziua! Aș dori să plasez o comandă la Florăria Passion.',
      '',
      `Produs: ${productTitle}`
    ];

    if (variantTitle) lines.push(`Varianta: ${variantTitle}`);

    if (giftMessage) {
      lines.push('Felicitare: Da – gratuită și scrisă manual');
      lines.push(`Mesaj felicitare: ${giftMessage}`);
    } else {
      lines.push('Felicitare: Nu am adăugat un mesaj');
    }

    lines.push(`Link produs: ${productUrl}`);
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(lines.join('\n'))}`;
  };

  const refreshProductWhatsappLinks = () => {
    const url = getProductWhatsappUrl();
    if (!url) return;
    $$('[data-product-whatsapp], [data-whatsapp-bubble]').forEach((link) => {
      link.href = url;
    });
  };

  const initReveal = (context = document) => {
    const items = $$('.reveal:not([data-reveal-ready])', context);
    if (!items.length) return;

    if (!document.body.classList.contains('motion-enabled') || !('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.revealReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });

    items.forEach((item, index) => {
      item.dataset.revealReady = 'true';
      const isStaggerCard = item.matches('.product-card, .collection-card, .service-card, .location-card, .article-card');
      const step = isStaggerCard ? 88 : 58;
      const maxIndex = isStaggerCard ? 5 : 4;
      item.style.transitionDelay = `${Math.min(index % (maxIndex + 1), maxIndex) * step}ms`;
      observer.observe(item);
    });
  };

  const initAnnouncements = (context = document) => {
    $$('[data-topbar-root]:not([data-initialized])', context).forEach((root) => {
      root.dataset.initialized = 'true';

      const centerDesktop = $$('[data-topbar-center-item]', root);
      const centerMobile = $$('[data-topbar-center-mobile-item]', root);
      const locationDesktop = $$('[data-topbar-location-item]', root);
      const locationMobile = $$('[data-topbar-location-mobile-item]', root);
      const mobileSlides = $$('[data-topbar-mobile-slide]', root);
      const prevButton = $('[data-topbar-mobile-prev]', root);
      const nextButton = $('[data-topbar-mobile-next]', root);
      const centerPrevButton = $('[data-topbar-center-prev]', root);
      const centerNextButton = $('[data-topbar-center-next]', root);
      const locationPrevButton = $('[data-topbar-location-prev]', root);
      const locationNextButton = $('[data-topbar-location-next]', root);

      let centerIndex = 0;
      let locationIndex = 0;
      let mobileIndex = 0;
      let centerTimer = null;
      let locationTimer = null;
      let mobileTimer = null;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const centerInterval = Number(root.dataset.centerInterval || 4000);
      const locationInterval = Number(root.dataset.locationInterval || 6000);
      const mobileInterval = Number(root.dataset.mobileInterval || 6000);

      const setActive = (items, nextIndex) => {
        if (!items.length) return 0;
        const normalized = (nextIndex + items.length) % items.length;
        items.forEach((item, index) => item.classList.toggle('is-active', index === normalized));
        return normalized;
      };

      const showCenter = (nextIndex) => {
        centerIndex = setActive(centerDesktop, nextIndex);
        setActive(centerMobile, centerIndex);
      };

      const showLocation = (nextIndex) => {
        locationIndex = setActive(locationDesktop, nextIndex);
        setActive(locationMobile, locationIndex);
      };

      const showMobile = (nextIndex) => {
        if (!mobileSlides.length) return;
        mobileIndex = (nextIndex + mobileSlides.length) % mobileSlides.length;
        mobileSlides.forEach((slide, index) => {
          const active = index === mobileIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };

      const startCenter = () => {
        window.clearInterval(centerTimer);
        if (reducedMotion || centerDesktop.length <= 1 || centerInterval <= 0) return;
        centerTimer = window.setInterval(() => showCenter(centerIndex + 1), centerInterval);
      };

      const startLocation = () => {
        window.clearInterval(locationTimer);
        if (reducedMotion || locationDesktop.length <= 1 || locationInterval <= 0) return;
        locationTimer = window.setInterval(() => showLocation(locationIndex + 1), locationInterval);
      };

      const startMobile = () => {
        window.clearInterval(mobileTimer);
        if (reducedMotion || mobileSlides.length <= 1 || mobileInterval <= 0) return;
        mobileTimer = window.setInterval(() => showMobile(mobileIndex + 1), mobileInterval);
      };

      centerPrevButton?.addEventListener('click', () => {
        showCenter(centerIndex - 1);
        startCenter();
      });

      centerNextButton?.addEventListener('click', () => {
        showCenter(centerIndex + 1);
        startCenter();
      });

      locationPrevButton?.addEventListener('click', () => {
        showLocation(locationIndex - 1);
        startLocation();
      });

      locationNextButton?.addEventListener('click', () => {
        showLocation(locationIndex + 1);
        startLocation();
      });

      prevButton?.addEventListener('click', () => {
        showMobile(mobileIndex - 1);
        startMobile();
      });

      nextButton?.addEventListener('click', () => {
        showMobile(mobileIndex + 1);
        startMobile();
      });

      root.addEventListener('mouseenter', () => {
        window.clearInterval(centerTimer);
        window.clearInterval(locationTimer);
        window.clearInterval(mobileTimer);
      });

      root.addEventListener('mouseleave', () => {
        startCenter();
        startLocation();
        startMobile();
      });

      showCenter(0);
      showLocation(0);
      showMobile(0);
      startCenter();
      startLocation();
      startMobile();
    });
  };

  const initHeader = () => {
    const header = $('[data-site-header]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  };

  const openMobileMenu = () => {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    $('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', 'true');
    updateBodyLock();
    window.setTimeout(() => $('[data-mobile-menu-close]', menu)?.focus(), 150);
  };

  const closeMobileMenu = () => {
    const menu = $('[data-mobile-menu]');
    if (!menu) return;
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    $('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    updateBodyLock();
  };

  const openFilterDrawer = () => {
    const drawer = $('[data-filter-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    updateBodyLock();
    window.setTimeout(() => $('[data-filter-close]', drawer)?.focus(), 120);
  };

  const closeFilterDrawer = () => {
    const drawer = $('[data-filter-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    updateBodyLock();
  };


  const openSearchModal = () => {
    const modal = $('[data-search-modal]');
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    $('[data-search-modal-open]')?.setAttribute('aria-expanded', 'true');
    updateBodyLock();
    window.setTimeout(() => $('[data-search-modal] [data-live-search-input]')?.focus(), 120);
  };

  const closeSearchModal = () => {
    const modal = $('[data-search-modal]');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    $('[data-search-modal-open]')?.setAttribute('aria-expanded', 'false');
    updateBodyLock();
  };

  const getCart = async () => {
    const response = await fetch(`${window.Passion.routes.cart}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error(window.Passion.strings.error);
    return response.json();
  };

  const updateCartCount = (count) => {
    $$('[data-cart-count]').forEach((element) => {
      element.textContent = count;
      element.hidden = Number(count) === 0;
    });
  };

  const refreshCartDrawer = async () => {
    const [sectionResponse, cart] = await Promise.all([
      fetch(`${window.Passion.routes.cart}?section_id=cart-drawer`),
      getCart()
    ]);
    if (!sectionResponse.ok) throw new Error(window.Passion.strings.error);
    const html = await sectionResponse.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = $('#CartDrawer', parsed);
    const current = $('#CartDrawer');
    if (replacement && current) current.replaceWith(replacement);
    updateCartCount(cart.item_count);
    return cart;
  };

  const openCartDrawer = () => {
    const drawer = $('#CartDrawer');
    if (!drawer) {
      window.location.href = window.Passion.routes.cart;
      return;
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    updateBodyLock();
    window.setTimeout(() => $('[data-cart-drawer-close]', drawer)?.focus(), 120);
  };

  const closeCartDrawer = () => {
    const drawer = $('#CartDrawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    updateBodyLock();
  };

  const changeCartLine = async (line, quantity) => {
    const drawer = $('#CartDrawer');
    drawer?.classList.add('is-loading');
    try {
      const response = await fetch(`${window.Passion.routes.cartChange}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || window.Passion.strings.error);
      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      showToast(error.message || window.Passion.strings.error);
    } finally {
      $('#CartDrawer')?.classList.remove('is-loading');
    }
  };

  const wait = (milliseconds) => new Promise((resolve) => window.setTimeout(resolve, milliseconds));

  const showAddedState = async (button) => {
    if (!button) return;
    const label = $('[data-add-to-cart-text]', button) || $('span', button);
    const originalLabel = label?.textContent || '';
    button.classList.remove('is-loading');
    button.classList.add('is-added');
    if (label) label.textContent = window.Passion.strings.addedToCart || '✓ Adăugat';
    await wait(620);
    window.setTimeout(() => {
      button.classList.remove('is-added');
      if (label && originalLabel) label.textContent = originalLabel;
    }, 900);
  };

  const addProductForm = async (form, submitter) => {
    if (!form || form.dataset.submitting === 'true') return;
    form.dataset.submitting = 'true';
    submitter?.classList.add('is-loading');
    submitter?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.Passion.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || window.Passion.strings.error);

      const confirmation = showAddedState(submitter);
      const cart = await refreshCartDrawer();
      await confirmation;
      if (window.Passion.openCartDrawer) {
        openCartDrawer();
      } else {
        showToast(`${payload.product_title || ''} — ${window.Passion.strings.addedToCart || window.Passion.strings.addToCart}`);
        updateCartCount(cart.item_count);
      }
    } catch (error) {
      showToast(error.message || window.Passion.strings.error);
    } finally {
      form.dataset.submitting = 'false';
      submitter?.classList.remove('is-loading');
      submitter?.removeAttribute('aria-busy');
    }
  };

  const initProductRoots = (context = document) => {
    $$('[data-product-root]:not([data-initialized])', context).forEach((root) => {
      root.dataset.initialized = 'true';
      const variantScript = $('[data-variant-json]', root);
      const form = $('.js-product-form', root);
      if (!variantScript || !form) return;

      let variants = [];
      try {
        variants = JSON.parse(variantScript.textContent);
      } catch (error) {
        console.warn('Passion theme: invalid variant JSON.', error);
      }

      const idInput = $('[name="id"]', form);
      const price = $('[data-product-price]', root);
      const comparePrice = $('[data-compare-price]', root);
      const addButton = $('[data-add-to-cart]', form);
      const addButtonText = $('[data-add-to-cart-text]', addButton || form);
      const status = $('[data-product-status]', root);
      const wishlistButton = $('[data-wishlist-toggle]', root);
      const whatsappLink = $('[data-product-whatsapp]', root);

      const selectedOptions = () => $$('[data-product-option]:checked', form).map((input) => input.value);

      const giftMessageInput = $('[name="properties[Mesaj felicitare]"]', form);

      const getCurrentVariant = () => {
        if (!variants.length) return null;
        const optionValues = selectedOptions();
        const optionInputs = $$('[data-product-option]', form);
        return optionInputs.length
          ? variants.find((candidate) => candidate.options.every((option, index) => option === optionValues[index])) || null
          : variants[0];
      };

      const updateWhatsappLink = (variant = getCurrentVariant()) => {
        if (!whatsappLink) return;

        const productTitle = whatsappLink.dataset.productTitle || document.title || 'produsul selectat';
        const baseProductUrl = whatsappLink.dataset.productUrl || window.location.href.split('?')[0];
        const variantTitle = variant?.title && variant.title !== 'Default Title' ? variant.title : '';
        const giftMessage = giftMessageInput?.value?.trim() || '';
        const number = whatsappLink.dataset.whatsappNumber || '40745951111';

        let productUrl = baseProductUrl;
        if (variant?.id) {
          try {
            const url = new URL(baseProductUrl, window.location.origin);
            url.searchParams.set('variant', variant.id);
            productUrl = url.toString();
          } catch (error) {
            productUrl = baseProductUrl;
          }
        }

        const messageLines = [
          'Bună ziua! Aș dori să plasez o comandă.',
          `Produs: ${productTitle}`
        ];

        if (variantTitle) messageLines.push(`Varianta selectată: ${variantTitle}`);

        if (giftMessage) {
          messageLines.push('Felicitare: Da, gratuită și scrisă manual');
          messageLines.push(`Mesaj felicitare: ${giftMessage}`);
        } else {
          messageLines.push('Felicitare: Nu am completat un mesaj');
        }

        messageLines.push(`Link produs: ${productUrl}`);
        whatsappLink.href = `https://wa.me/${number}?text=${encodeURIComponent(messageLines.join('\n'))}`;
      };

      const updateVariant = () => {
        if (!variants.length) return;
        const optionValues = selectedOptions();
        const optionInputs = $$('[data-product-option]', form);
        const variant = optionInputs.length
          ? variants.find((candidate) => candidate.options.every((option, index) => option === optionValues[index]))
          : variants[0];

        if (!variant) {
          updateWhatsappLink(null);
          if (addButton) addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = window.Passion.strings.unavailable;
          status?.classList.add('is-unavailable');
          if (status) status.textContent = window.Passion.strings.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;
        updateWhatsappLink(variant);
        if (price) price.textContent = formatMoney(variant.price);
        if (wishlistButton) {
          wishlistButton.dataset.wishlistPrice = formatMoney(variant.price);
          wishlistButton.dataset.wishlistVariantId = variant.id;
        }

        if (comparePrice) {
          const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          comparePrice.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
          comparePrice.hidden = !hasCompare;
        }

        if (addButton) addButton.disabled = !variant.available;
        if (addButtonText) addButtonText.textContent = variant.available ? window.Passion.strings.addToCart : window.Passion.strings.soldOut;
        if (status) {
          status.classList.toggle('is-unavailable', !variant.available);
          status.textContent = variant.available ? status.dataset.availableText : window.Passion.strings.soldOut;
        }

        if (history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        if (variant.featured_media?.id) {
          const mediaButton = $(`[data-media-target="${variant.featured_media.id}"]`, root);
          mediaButton?.click();
        }
      };

      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-product-option]')) updateVariant();
        if (event.target === giftMessageInput) updateWhatsappLink();
      });

      giftMessageInput?.addEventListener('input', () => updateWhatsappLink());

      whatsappLink?.addEventListener('click', (event) => {
        // Rebuild the message at click time and navigate explicitly. This avoids
        // falling back to the generic floating WhatsApp bubble message.
        event.preventDefault();
        updateWhatsappLink();
        const targetUrl = whatsappLink.href;
        const opened = window.open(targetUrl, '_blank');
        if (opened) {
          try { opened.opener = null; } catch (error) {}
        } else {
          window.location.assign(targetUrl);
        }
      });

      updateVariant();
    });
  };

  const initCharacterCounters = (context = document) => {
    $$('[data-character-input]:not([data-initialized])', context).forEach((input) => {
      input.dataset.initialized = 'true';
      const target = input.closest('.field')?.querySelector('[data-character-count]');
      const update = () => {
        if (target) target.textContent = input.value.length;
      };
      input.addEventListener('input', update);
      update();
    });
  };

  const initSliderControls = (context = document) => {
    $$('[data-slider]:not([data-initialized])', context).forEach((slider) => {
      slider.dataset.initialized = 'true';
      const track = $('[data-slider-track]', slider);
      if (!track) return;
      const scroll = (direction) => {
        const firstCard = track.firstElementChild;
        const amount = firstCard ? firstCard.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      };
      $('[data-slider-prev]', slider)?.addEventListener('click', () => scroll(-1));
      $('[data-slider-next]', slider)?.addEventListener('click', () => scroll(1));
    });
  };

  const activateGalleryMedia = (root, mediaId, shouldScroll = true) => {
    const targetId = String(mediaId);
    const targetMedia = $$('[data-product-media]', root).find((media) => media.dataset.productMedia === targetId);
    const targetThumbnail = $$('[data-media-target]', root).find((button) => button.dataset.mediaTarget === targetId);

    $$('[data-product-media]', root).forEach((media) => media.classList.toggle('is-active', media.dataset.productMedia === targetId));
    $$('[data-media-target]', root).forEach((button) => {
      const isActive = button.dataset.mediaTarget === targetId;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const zoomButton = $('[data-product-zoom]', root);
    const targetImage = targetMedia ? $('img', targetMedia) : null;
    if (zoomButton) {
      zoomButton.hidden = !targetImage;
      if (targetImage && targetMedia) {
        zoomButton.dataset.productZoom = targetMedia.dataset.productZoomSource || targetImage.currentSrc || targetImage.src || '';
        zoomButton.dataset.productZoomAlt = targetMedia.dataset.productZoomAlt || targetImage.alt || '';
      }
    }

    if (!shouldScroll || !window.matchMedia('(max-width: 989px)').matches || !targetMedia) return;

    const viewport = $('.product-gallery__viewport', root);
    if (viewport) {
      const viewportRect = viewport.getBoundingClientRect();
      const mediaRect = targetMedia.getBoundingClientRect();
      const targetLeft = viewport.scrollLeft + mediaRect.left - viewportRect.left;
      viewport.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }

    const thumbnails = targetThumbnail?.closest('.product-gallery__thumbnails');
    if (thumbnails && targetThumbnail) {
      const thumbsRect = thumbnails.getBoundingClientRect();
      const thumbRect = targetThumbnail.getBoundingClientRect();
      const targetLeft = thumbnails.scrollLeft + thumbRect.left - thumbsRect.left - (thumbsRect.width - thumbRect.width) / 2;
      thumbnails.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
    }
  };

  const initProductGalleries = (context = document) => {
    $$('[data-product-root]:not([data-gallery-initialized])', context).forEach((root) => {
      root.dataset.galleryInitialized = 'true';
      const viewport = $('.product-gallery__viewport', root);
      const mediaItems = $$('[data-product-media]', root);
      if (!viewport || mediaItems.length < 2) return;

      let scrollTimer;
      viewport.addEventListener('scroll', () => {
        if (!window.matchMedia('(max-width: 989px)').matches) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const viewportRect = viewport.getBoundingClientRect();
          const viewportCenter = viewportRect.left + viewportRect.width / 2;
          let closest = mediaItems[0];
          let closestDistance = Infinity;

          mediaItems.forEach((media) => {
            const rect = media.getBoundingClientRect();
            const mediaCenter = rect.left + rect.width / 2;
            const distance = Math.abs(mediaCenter - viewportCenter);
            if (distance < closestDistance) {
              closest = media;
              closestDistance = distance;
            }
          });

          if (closest?.dataset.productMedia) activateGalleryMedia(root, closest.dataset.productMedia, false);
        }, 90);
      }, { passive: true });
    });
  };

  let lightboxScale = 1;

  const setLightboxScale = (nextScale) => {
    const dialog = $('[data-product-lightbox]');
    const image = $('[data-lightbox-image]', dialog || document);
    const resetButton = $('[data-lightbox-reset]', dialog || document);
    if (!dialog || !image) return;
    lightboxScale = Math.min(3, Math.max(1, Number(nextScale) || 1));
    image.style.setProperty('--lightbox-scale', lightboxScale);
    image.classList.toggle('is-zoomed', lightboxScale > 1.01);
    if (resetButton) resetButton.textContent = `${Math.round(lightboxScale * 100)}%`;
  };

  const openLightbox = (source, alt = '') => {
    const dialog = $('[data-product-lightbox]');
    const image = $('[data-lightbox-image]', dialog || document);
    if (!dialog || !image || !source) return;
    image.src = source;
    image.alt = alt;
    setLightboxScale(1);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    updateBodyLock();
  };

  const closeLightbox = () => {
    const dialog = $('[data-product-lightbox]');
    if (!dialog) return;
    setLightboxScale(1);
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    updateBodyLock();
  };

  const initProductLightbox = (context = document) => {
    $$('[data-product-lightbox]:not([data-lightbox-initialized])', context).forEach((dialog) => {
      dialog.dataset.lightboxInitialized = 'true';
      const stage = $('[data-lightbox-stage]', dialog);
      const image = $('[data-lightbox-image]', dialog);
      if (!stage || !image) return;

      stage.addEventListener('wheel', (event) => {
        if (!dialog.open) return;
        event.preventDefault();
        const direction = event.deltaY < 0 ? 0.2 : -0.2;
        setLightboxScale(lightboxScale + direction);
      }, { passive: false });

      image.addEventListener('dblclick', (event) => {
        event.preventDefault();
        setLightboxScale(lightboxScale > 1 ? 1 : 2);
      });
    });
  };

  const initDesktopFilters = (context = document) => {
    $$('[data-filter-form]:not([data-initialized])', context).forEach((form) => {
      form.dataset.initialized = 'true';
      let timer;
      form.addEventListener('change', (event) => {
        if (event.target.matches('[data-filter-input]') && window.matchMedia('(min-width: 990px)').matches) {
          window.clearTimeout(timer);
          timer = window.setTimeout(() => form.submit(), 260);
        }
      });
    });
  };

  const escapeHtml = (value = '') => String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  const initLiveSearch = (context = document) => {
    $$('[data-live-search]:not([data-live-search-initialized])', context).forEach((form) => {
      form.dataset.liveSearchInitialized = 'true';
      const input = $('[data-live-search-input]', form);
      const results = $('[data-live-search-results]', form);
      if (!input || !results || !window.Passion?.routes?.predictiveSearch) return;

      let debounceTimer;
      let controller;

      const closeResults = () => {
        results.hidden = true;
        results.classList.remove('is-visible');
      };

      const openResults = () => {
        results.hidden = false;
        requestAnimationFrame(() => results.classList.add('is-visible'));
      };

      const buildProduct = (product) => {
        const imageUrl = product.featured_image?.url || product.image || '';
        const imageAlt = product.featured_image?.alt || product.title || '';
        const availability = product.available === false ? 'Indisponibil' : 'Disponibil';
        const image = imageUrl
          ? `<img class="live-search-result__image" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(imageAlt)}" loading="lazy">`
          : '<span class="live-search-result__image live-search-result__image--placeholder" aria-hidden="true"></span>';

        return `
          <a class="live-search-result" href="${escapeHtml(product.url)}">
            ${image}
            <span class="live-search-result__content">
              <strong class="live-search-result__title">${escapeHtml(product.title)}</strong>
              <span class="live-search-result__meta">${availability}</span>
            </span>
            <span class="live-search-result__arrow passion-icon passion-icon--arrow" aria-hidden="true"></span>
          </a>`;
      };

      const performSearch = async (query) => {
        controller?.abort();
        controller = new AbortController();

        results.innerHTML = `<div class="live-search-results__status">${escapeHtml(window.Passion.strings.searchLoading)}</div>`;
        openResults();

        try {
          const url = new URL(window.Passion.routes.predictiveSearch, window.location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('resources[type]', 'product');
          url.searchParams.set('resources[limit]', '6');
          url.searchParams.set('resources[options][unavailable_products]', 'last');
          url.searchParams.set('resources[options][prefix]', 'last');
          url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor');

          const response = await fetch(url.toString(), {
            headers: { Accept: 'application/json' },
            signal: controller.signal
          });
          if (!response.ok) throw new Error(window.Passion.strings.error);
          const payload = await response.json();
          if (input.value.trim() !== query) return;

          const products = payload?.resources?.results?.products || [];
          if (!products.length) {
            results.innerHTML = `<div class="live-search-results__status">${escapeHtml(window.Passion.strings.searchNoResults)}</div>`;
            openResults();
            return;
          }

          const allResultsUrl = new URL(window.Passion.routes.search, window.location.origin);
          allResultsUrl.searchParams.set('q', query);
          allResultsUrl.searchParams.set('options[prefix]', 'last');

          results.innerHTML = `
            <div class="live-search-results__list">
              ${products.map(buildProduct).join('')}
            </div>
            <a class="live-search-results__all" href="${allResultsUrl.toString()}">
              ${escapeHtml(window.Passion.strings.searchViewAll)}
              <span class="passion-icon passion-icon--arrow" aria-hidden="true"></span>
            </a>`;
          openResults();
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.innerHTML = `<div class="live-search-results__status">${escapeHtml(window.Passion.strings.searchNoResults)}</div>`;
          openResults();
        }
      };

      input.addEventListener('input', () => {
        const query = input.value.trim();
        window.clearTimeout(debounceTimer);

        if (query.length < 3) {
          controller?.abort();
          results.innerHTML = '';
          closeResults();
          return;
        }

        debounceTimer = window.setTimeout(() => performSearch(query), 260);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 3 && results.innerHTML.trim()) openResults();
      });

      form.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeResults();
      });

      // Capture before any component-specific handler. This makes the product CTA
  // and the floating WhatsApp bubble use the same live product message.
  document.addEventListener('click', (event) => {
    if (!$('[data-product-root]')) return;
    const whatsappTarget = event.target.closest('[data-product-whatsapp], [data-whatsapp-bubble]');
    if (!whatsappTarget) return;
    const url = getProductWhatsappUrl();
    if (url) whatsappTarget.href = url;
  }, true);

  document.addEventListener('change', (event) => {
    if (!$('[data-product-root]')) return;
    if (event.target.matches('[data-product-option], [name="properties[Mesaj felicitare]"]')) {
      window.setTimeout(refreshProductWhatsappLinks, 0);
    }
  }, true);

  document.addEventListener('input', (event) => {
    if (!$('[data-product-root]')) return;
    if (event.target.matches('[name="properties[Mesaj felicitare]"]')) refreshProductWhatsappLinks();
  }, true);

  document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults();
      });
    });
  };



  const initTestimonialsSliders = (context = document) => {
    $$('[data-testimonials-slider]:not([data-initialized])', context).forEach((slider) => {
      slider.dataset.initialized = 'true';
      const track = $('[data-testimonials-track]', slider);
      const slides = $$('[data-testimonials-slide]', slider);
      const prevButton = $('[data-testimonials-prev]', slider);
      const nextButton = $('[data-testimonials-next]', slider);
      const dots = $$('[data-testimonials-dot]', slider);
      if (!track || !slides.length) return;

      let currentIndex = 0;
      let autoplay = null;
      let pointerStartX = null;
      let pointerStartY = null;
      let activePointerId = null;
      let resizeTimer = null;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayDelay = Number(slider.dataset.autoplay || 6000);

      const visibleCount = () => {
        if (window.innerWidth >= 1200) return Math.min(4, slides.length);
        if (window.innerWidth >= 990) return Math.min(3, slides.length);
        if (window.innerWidth >= 750) return Math.min(2, slides.length);
        return 1;
      };

      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const update = (animate = true) => {
        currentIndex = Math.min(Math.max(currentIndex, 0), maxIndex());
        track.style.transitionDuration = animate && !reducedMotion ? '' : '0ms';
        const target = slides[currentIndex];
        const offset = target ? target.offsetLeft : 0;
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;

        dots.forEach((dot, index) => {
          const available = index <= maxIndex();
          dot.hidden = !available;
          const active = available && index === currentIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        const max = maxIndex();
        if (max <= 0) {
          currentIndex = 0;
        } else if (index > max) {
          currentIndex = 0;
        } else if (index < 0) {
          currentIndex = max;
        } else {
          currentIndex = index;
        }
        update();
      };

      const restartAutoplay = () => {
        window.clearInterval(autoplay);
        if (reducedMotion || maxIndex() <= 0 || autoplayDelay <= 0) return;
        autoplay = window.setInterval(() => goTo(currentIndex + 1), autoplayDelay);
      };

      prevButton?.addEventListener('click', () => {
        goTo(currentIndex - 1);
        restartAutoplay();
      });

      nextButton?.addEventListener('click', () => {
        goTo(currentIndex + 1);
        restartAutoplay();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.index || 0));
          restartAutoplay();
        });
      });

      const swipeSurface = $('[data-testimonials-track]', slider)?.parentElement || slider;

      swipeSurface.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
        activePointerId = event.pointerId;
        if (typeof swipeSurface.setPointerCapture === 'function') {
          try { swipeSurface.setPointerCapture(event.pointerId); } catch (error) {}
        }
      });

      swipeSurface.addEventListener('pointerup', (event) => {
        if (pointerStartX == null || (activePointerId != null && event.pointerId !== activePointerId)) return;
        const distanceX = event.clientX - pointerStartX;
        const distanceY = event.clientY - pointerStartY;
        pointerStartX = null;
        pointerStartY = null;
        activePointerId = null;
        if (Math.abs(distanceX) < 36 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        goTo(distanceX < 0 ? currentIndex + 1 : currentIndex - 1);
        restartAutoplay();
      });

      swipeSurface.addEventListener('pointercancel', () => {
        pointerStartX = null;
        pointerStartY = null;
        activePointerId = null;
      });

      slider.addEventListener('mouseenter', () => window.clearInterval(autoplay));
      slider.addEventListener('mouseleave', restartAutoplay);
      slider.addEventListener('focusin', () => window.clearInterval(autoplay));
      slider.addEventListener('focusout', restartAutoplay);

      window.addEventListener('resize', () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
          currentIndex = Math.min(currentIndex, maxIndex());
          update(false);
          restartAutoplay();
          requestAnimationFrame(() => { track.style.transitionDuration = ''; });
        }, 120);
      }, { passive: true });

      update(false);
      requestAnimationFrame(() => { track.style.transitionDuration = ''; });
      restartAutoplay();
    });
  };

  const initFaqAccordion = (context = document) => {
    $$('[data-faq-item]:not([data-initialized])', context).forEach((item) => {
      item.dataset.initialized = 'true';
      const summary = $('summary', item);
      const answerWrap = $('[data-faq-answer-wrap]', item);
      if (!summary || !answerWrap) return;

      answerWrap.style.height = item.open ? 'auto' : '0px';

      summary.addEventListener('click', (event) => {
        event.preventDefault();
        const isOpen = item.open;

        if (isOpen) {
          const startHeight = answerWrap.scrollHeight;
          answerWrap.style.height = `${startHeight}px`;
          requestAnimationFrame(() => {
            answerWrap.style.height = '0px';
          });
          const onClose = () => {
            item.open = false;
            answerWrap.removeEventListener('transitionend', onClose);
          };
          answerWrap.addEventListener('transitionend', onClose, { once: true });
          return;
        }

        item.open = true;
        answerWrap.style.height = '0px';
        requestAnimationFrame(() => {
          answerWrap.style.height = `${answerWrap.scrollHeight}px`;
        });
        const onOpen = () => {
          answerWrap.style.height = 'auto';
          answerWrap.removeEventListener('transitionend', onOpen);
        };
        answerWrap.addEventListener('transitionend', onOpen, { once: true });
      });
    });
  };

  const initImageLoading = (context = document) => {
    const selector = [
      '.product-card__image',
      '.collection-card__image',
      '.story-split__image',
      '.custom-bouquet__image',
      '.product-gallery__media img',
      '.page-hero__image',
      '.cart-item__image',
      '.article-card img',
      '.services-hero__image',
      '.service-feature__image',
      '.services-process__image',
      '.services-cta__image',
      '.about-hero__image',
      '.about-story__image',
      '.about-philosophy__image',
      '.about-team__image',
      '.about-locations__image',
      '.about-cta__image',
      '.home-universe__image img'
    ].join(', ');

    $$(selector, context).forEach((image) => {
      if (image.dataset.blurReady === 'true') return;
      image.dataset.blurReady = 'true';
      image.classList.add('image-blur-up');

      const holder = image.closest('.product-card__media-link, .collection-card__media, .product-gallery__media, .story-split__media, .custom-bouquet__media, .page-hero__media, .cart-item__media, .article-card, .services-hero__media, .service-feature__media, .services-process__media, .services-cta__media, .about-hero__media, .about-story__media, .about-philosophy__media, .about-team__media, .about-locations__media, .about-cta__media, .home-universe__image, .home-contact-delivery__media, .home-contact-delivery__media-v2, .media') || image.parentElement;
      holder?.classList.add('image-skeleton');
      if (holder && !holder.querySelector(':scope > .image-skeleton__layer')) {
        const skeletonLayer = document.createElement('span');
        skeletonLayer.className = 'image-skeleton__layer';
        skeletonLayer.setAttribute('aria-hidden', 'true');
        holder.appendChild(skeletonLayer);
      }

      const revealImage = () => {
        image.classList.add('is-loaded');
        holder?.classList.add('is-image-loaded');
      };

      if (image.complete && image.naturalWidth > 0) {
        revealImage();
      } else {
        image.addEventListener('load', revealImage, { once: true });
        image.addEventListener('error', revealImage, { once: true });
      }
    });
  };

  const initPremiumInteractions = (context = document) => {
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reducedMotion) return;

    const cursor = $('[data-boutique-cursor]');
    if (cursor && cursor.dataset.initialized !== 'true') {
      cursor.dataset.initialized = 'true';
      document.body.classList.add('has-boutique-cursor');
      document.addEventListener('pointermove', (event) => {
        cursor.style.transform = `translate3d(${event.clientX}px, ${event.clientY}px, 0) translate(-50%, -50%)`;
      }, { passive: true });
    }

    $$('[data-magnetic]:not([data-magnetic-ready])', context).forEach((button) => {
      button.dataset.magneticReady = 'true';

      button.addEventListener('pointerenter', () => {
        cursor?.classList.add('is-visible');
        button.classList.add('is-magnetic-active');
      });

      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        const offsetX = ((event.clientX - rect.left) / rect.width - 0.5) * 12;
        const offsetY = ((event.clientY - rect.top) / rect.height - 0.5) * 10;
        button.style.setProperty('--magnetic-x', `${offsetX}px`);
        button.style.setProperty('--magnetic-y', `${offsetY}px`);
      });

      button.addEventListener('pointerleave', () => {
        cursor?.classList.remove('is-visible');
        button.classList.remove('is-magnetic-active');
        button.style.setProperty('--magnetic-x', '0px');
        button.style.setProperty('--magnetic-y', '0px');
      });
    });

    $$('[data-hero-parallax]:not([data-parallax-ready])', context).forEach((hero) => {
      hero.dataset.parallaxReady = 'true';
      const image = $('.editorial-hero__image', hero);
      if (!image) return;
      let ticking = false;

      const updateParallax = () => {
        ticking = false;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const centerDelta = (window.innerHeight / 2) - (rect.top + rect.height / 2);
        const normalized = Math.max(-1, Math.min(1, centerDelta / Math.max(window.innerHeight, rect.height)));
        const offset = normalized * 14;
        image.style.setProperty('--hero-parallax-y', `${offset.toFixed(2)}px`);
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateParallax);
      };

      updateParallax();
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
    });
  };

  const WISHLIST_KEY = 'passion:wishlist:v1';

  const readWishlist = () => {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    } catch (error) {
      console.warn('Passion theme: favoritele nu au putut fi salvate local.', error);
    }
  };

  const openWishlistDrawer = () => {
    const drawer = $('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $('[data-wishlist-open]')?.setAttribute('aria-expanded', 'true');
    updateBodyLock();
    window.setTimeout(() => $('[data-wishlist-close]', drawer)?.focus(), 120);
  };

  const closeWishlistDrawer = () => {
    const drawer = $('[data-wishlist-drawer]');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $('[data-wishlist-open]')?.setAttribute('aria-expanded', 'false');
    updateBodyLock();
  };

  const renderWishlist = () => {
    const items = readWishlist();
    const handles = new Set(items.map((item) => item.handle));

    $$('[data-wishlist-count]').forEach((counter) => {
      counter.textContent = items.length;
      counter.hidden = items.length === 0;
    });
    $$('[data-wishlist-open]').forEach((button) => button.classList.toggle('has-items', items.length > 0));

    $$('[data-wishlist-toggle]').forEach((button) => {
      const isActive = handles.has(button.dataset.wishlistHandle);
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      const label = $('[data-wishlist-label]', button);
      if (label) label.textContent = isActive ? 'Salvat la favorite' : 'Adaugă la favorite';
    });

    const container = $('[data-wishlist-items]');
    const empty = $('[data-wishlist-empty]');
    if (!container || !empty) return;

    empty.hidden = items.length > 0;
    container.hidden = items.length === 0;
    container.innerHTML = items.map((item) => `
      <article class="wishlist-item">
        <a class="wishlist-item__image" href="${escapeHtml(item.url)}">
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<span class="wishlist-item__placeholder"></span>'}
        </a>
        <div class="wishlist-item__content">
          <a class="wishlist-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a>
          <span class="wishlist-item__price">${escapeHtml(item.price || '')}</span>
          <div class="wishlist-item__actions">
            <button class="wishlist-item__add" type="button" data-wishlist-add="${escapeHtml(item.handle)}" data-wishlist-variant-id="${escapeHtml(String(item.variantId || ''))}">
              <span class="passion-icon passion-icon--bag" aria-hidden="true"></span>
              <span data-add-to-cart-text>Adaugă în coș</span>
            </button>
            <button class="wishlist-item__remove" type="button" data-wishlist-remove="${escapeHtml(item.handle)}">Elimină</button>
          </div>
        </div>
      </article>
    `).join('');
  };

  const resolveWishlistVariantId = async (item) => {
    const storedId = Number(item?.variantId || 0);
    if (storedId) return storedId;

    const productUrl = String(item?.url || '').split('?')[0].replace(/\/$/, '');
    if (!productUrl) throw new Error('Produsul nu a putut fi identificat.');

    const response = await fetch(`${productUrl}.js`, { headers: { Accept: 'application/json' } });
    const product = await response.json();
    if (!response.ok) throw new Error(product.description || window.Passion.strings.error);
    const variant = Array.isArray(product.variants) ? product.variants.find((candidate) => candidate.available) : null;
    if (!variant) throw new Error(window.Passion.strings.soldOut || 'Produs indisponibil');
    return Number(variant.id);
  };

  const addWishlistItemToCart = async (button) => {
    if (!button || button.dataset.submitting === 'true') return;
    const handle = button.dataset.wishlistAdd;
    const item = readWishlist().find((candidate) => candidate.handle === handle);
    if (!item) return;

    button.dataset.submitting = 'true';
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    try {
      const variantId = Number(button.dataset.wishlistVariantId || item.variantId || 0) || await resolveWishlistVariantId(item);
      button.dataset.wishlistVariantId = String(variantId);

      if (!item.variantId) {
        const updatedItems = readWishlist().map((candidate) => candidate.handle === handle ? { ...candidate, variantId: String(variantId) } : candidate);
        writeWishlist(updatedItems);
      }

      const formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', '1');

      const response = await fetch(`${window.Passion.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || window.Passion.strings.error);

      const confirmation = showAddedState(button);
      const cart = await refreshCartDrawer();
      await confirmation;
      closeWishlistDrawer();
      if (window.Passion.openCartDrawer) {
        openCartDrawer();
      } else {
        showToast(`${payload.product_title || item.title || ''} — ${window.Passion.strings.addedToCart || window.Passion.strings.addToCart}`);
        updateCartCount(cart.item_count);
      }
    } catch (error) {
      showToast(error.message || window.Passion.strings.error);
    } finally {
      button.dataset.submitting = 'false';
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
    }
  };

  const toggleWishlist = (button) => {
    const handle = button.dataset.wishlistHandle;
    if (!handle) return;

    const items = readWishlist();
    const existingIndex = items.findIndex((item) => item.handle === handle);

    if (existingIndex >= 0) {
      items.splice(existingIndex, 1);
      writeWishlist(items);
      showToast(window.Passion.strings.wishlistRemoved || 'Eliminat din favorite');
    } else {
      items.unshift({
        handle,
        title: button.dataset.wishlistTitle || '',
        url: button.dataset.wishlistUrl || '#',
        image: button.dataset.wishlistImage || '',
        price: button.dataset.wishlistPrice || '',
        variantId: button.dataset.wishlistVariantId || ''
      });
      writeWishlist(items.slice(0, 30));
      showToast(window.Passion.strings.wishlistAdded || 'Adăugat la favorite');
    }

    renderWishlist();
  };

  const initWishlist = () => {
    renderWishlist();
    if (document.documentElement.dataset.wishlistStorageReady === 'true') return;
    document.documentElement.dataset.wishlistStorageReady = 'true';
    window.addEventListener('storage', (event) => {
      if (event.key === WISHLIST_KEY) renderWishlist();
    });
  };

  const init = (context = document) => {
    initReveal(context);
    initAnnouncements(context);
    initProductRoots(context);
    initProductGalleries(context);
    initProductLightbox(context);
    initCharacterCounters(context);
    initSliderControls(context);
    initDesktopFilters(context);
    initLiveSearch(context);
    initFaqAccordion(context);
    initTestimonialsSliders(context);
    initImageLoading(context);
    initPremiumInteractions(context);
    initWishlist();
  };

  document.addEventListener('click', (event) => {
    const mobileToggle = event.target.closest('[data-mobile-menu-toggle]');
    if (mobileToggle) {
      event.preventDefault();
      openMobileMenu();
      return;
    }

    if (event.target.closest('[data-mobile-menu-close], [data-mobile-menu-overlay]')) {
      closeMobileMenu();
      return;
    }

    const cartTrigger = event.target.closest('[data-cart-open]');
    if (cartTrigger) {
      event.preventDefault();
      openCartDrawer();
      return;
    }

    if (event.target.closest('[data-cart-drawer-close], [data-cart-drawer-overlay]')) {
      closeCartDrawer();
      return;
    }

    if (event.target.closest('[data-filter-open]')) {
      event.preventDefault();
      openFilterDrawer();
      return;
    }

    if (event.target.closest('[data-filter-close], [data-filter-overlay]')) {
      closeFilterDrawer();
      return;
    }

    if (event.target.closest('[data-search-modal-open]')) {
      event.preventDefault();
      openSearchModal();
      return;
    }

    if (event.target.closest('[data-search-modal-close]')) {
      closeSearchModal();
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      openWishlistDrawer();
      return;
    }

    if (event.target.closest('[data-wishlist-close]')) {
      closeWishlistDrawer();
      return;
    }

    const wishlistToggle = event.target.closest('[data-wishlist-toggle]');
    if (wishlistToggle) {
      event.preventDefault();
      event.stopPropagation();
      toggleWishlist(wishlistToggle);
      return;
    }

    const wishlistAdd = event.target.closest('[data-wishlist-add]');
    if (wishlistAdd) {
      event.preventDefault();
      event.stopPropagation();
      addWishlistItemToCart(wishlistAdd);
      return;
    }

    const wishlistRemove = event.target.closest('[data-wishlist-remove]');
    if (wishlistRemove) {
      event.preventDefault();
      const items = readWishlist().filter((item) => item.handle !== wishlistRemove.dataset.wishlistRemove);
      writeWishlist(items);
      renderWishlist();
      showToast(window.Passion.strings.wishlistRemoved || 'Eliminat din favorite');
      return;
    }

    const quantityButton = event.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (quantityButton) {
      event.preventDefault();
      const wrapper = quantityButton.closest('[data-quantity-wrapper]');
      const input = $('input[type="number"]', wrapper || document);
      if (!input) return;
      const step = Number(input.step || 1);
      const min = Number(input.min || 0);
      const max = input.max ? Number(input.max) : Infinity;
      const next = quantityButton.hasAttribute('data-quantity-plus')
        ? Math.min(Number(input.value || 0) + step, max)
        : Math.max(Number(input.value || 0) - step, min);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const line = wrapper?.dataset.cartLine;
      if (line) changeCartLine(line, next);
      return;
    }

    const removeLine = event.target.closest('[data-cart-remove]');
    if (removeLine) {
      event.preventDefault();
      changeCartLine(removeLine.dataset.cartRemove, 0);
      return;
    }

    const productCard = event.target.closest('[data-product-card][data-product-url]');
    if (productCard && !event.target.closest('a, button, form, input, select, textarea, label')) {
      window.location.href = productCard.dataset.productUrl;
      return;
    }

    const thumbArrow = event.target.closest('[data-product-thumbs-prev], [data-product-thumbs-next]');
    if (thumbArrow) {
      event.preventDefault();
      const root = thumbArrow.closest('[data-product-root]');
      if (!root) return;
      const thumbnails = $$('[data-media-target]', root);
      if (!thumbnails.length) return;
      const activeIndex = Math.max(0, thumbnails.findIndex((button) => button.classList.contains('is-active')));
      const direction = thumbArrow.matches('[data-product-thumbs-prev]') ? -1 : 1;
      const nextIndex = Math.min(thumbnails.length - 1, Math.max(0, activeIndex + direction));
      const target = thumbnails[nextIndex];
      if (target) {
        activateGalleryMedia(root, target.dataset.mediaTarget);
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
      return;
    }

    const thumbnail = event.target.closest('[data-media-target]');
    if (thumbnail) {
      event.preventDefault();
      const root = thumbnail.closest('[data-product-root]');
      if (root) activateGalleryMedia(root, thumbnail.dataset.mediaTarget);
      return;
    }

    const zoom = event.target.closest('[data-product-zoom]');
    if (zoom) {
      event.preventDefault();
      const root = zoom.closest('[data-product-root]');
      const activeImage = root ? $('.product-gallery__media.is-active img', root) : null;
      const source = activeImage?.currentSrc || activeImage?.src || zoom.dataset.productZoom || '';
      const alt = activeImage?.alt || zoom.dataset.productZoomAlt || '';
      openLightbox(source, alt);
      return;
    }

    if (event.target.closest('[data-lightbox-close]')) {
      event.preventDefault();
      closeLightbox();
      return;
    }

    if (event.target.closest('[data-lightbox-zoom-in]')) {
      event.preventDefault();
      setLightboxScale(lightboxScale + 0.25);
      return;
    }

    if (event.target.closest('[data-lightbox-zoom-out]')) {
      event.preventDefault();
      setLightboxScale(lightboxScale - 0.25);
      return;
    }

    if (event.target.closest('[data-lightbox-reset]')) {
      event.preventDefault();
      setLightboxScale(1);
      return;
    }
  });

  document.addEventListener('change', (event) => {
    const drawerQuantity = event.target.closest('[data-cart-quantity-input]');
    if (drawerQuantity && !event.isTrusted) return;
    if (drawerQuantity) {
      changeCartLine(drawerQuantity.dataset.cartLine, drawerQuantity.value);
    }

    if (event.target.matches('[data-sort-select]')) {
      event.target.form?.submit();
    }
  });

  document.addEventListener('submit', (event) => {
    const productForm = event.target.closest('form.js-product-form');
    if (!productForm) return;
    event.preventDefault();
    addProductForm(productForm, event.submitter);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMobileMenu();
    closeCartDrawer();
    closeFilterDrawer();
    closeLightbox();
    closeSearchModal();
    closeWishlistDrawer();
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-product-lightbox]');
    if (!dialog) return;
    const stage = event.target.closest('[data-lightbox-stage]');
    const image = event.target.closest('[data-lightbox-image]');
    if (event.target === dialog || (stage && !image && event.target === stage)) closeLightbox();
  });

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('passion:content-loaded', (event) => init(event.detail?.element || document));

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    init();
    refreshProductWhatsappLinks();
  });
})();
